var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from '../utils/clsx';
import { styled } from '../styled';
import { TitleBlock } from '../title-block';
import { avatarBlockClasses, avatarBlockComponentName, getAvatarBlockUtilityClass, } from './avatar-block-classes';
import { useMergedClasses } from '../styles/classes';
var Root = styled('div', {
    name: avatarBlockComponentName,
    slot: 'Root',
})(function (_a) {
    var ownerState = _a.ownerState, theme = _a.theme;
    return ({
        display: 'flex',
        gap: theme.spacing(ownerState.size === 'large' ? 3 : 2),
        alignItems: ownerState.description ? 'flex-start' : 'center',
    });
});
var Avatar = styled('div', {
    name: avatarBlockComponentName,
    slot: 'Avatar',
})({});
var EndAdornment = styled('div', {
    name: avatarBlockComponentName,
    slot: 'EndAdornment',
})(function (_a) {
    var theme = _a.theme;
    return ({
        alignSelf: 'center',
        color: theme.tokens.color_fg_decorative,
    });
});
var titleVariantMap = {
    medium: 'subtitle2',
    large: 'subtitle1',
};
export var AvatarBlock = React.forwardRef(function (props, ref) {
    var avatar = props.avatar, title = props.title, description = props.description, titleTypographyProps = props.titleTypographyProps, descriptionTypographyProps = props.descriptionTypographyProps, _a = props.TitleBlockProps, TitleBlockProps = _a === void 0 ? {} : _a, className = props.className, _b = props.size, size = _b === void 0 ? 'medium' : _b, endAdornment = props.endAdornment, rootProps = __rest(props, ["avatar", "title", "description", "titleTypographyProps", "descriptionTypographyProps", "TitleBlockProps", "className", "size", "endAdornment"]);
    var classes = useMergedClasses(avatarBlockClasses, getAvatarBlockUtilityClass, props.classes);
    var titleVariant = titleVariantMap[size];
    return (React.createElement(Root, __assign({ ownerState: { description: description, size: size }, ref: ref, className: clsx(classes.root, className) }, rootProps),
        avatar && React.createElement(Avatar, { className: classes.avatar }, avatar),
        React.createElement(TitleBlock, __assign({ className: classes.titleBlock, title: title, description: description, titleTypographyProps: __assign({ noWrap: true, component: 'p', variant: titleVariant }, titleTypographyProps), descriptionTypographyProps: descriptionTypographyProps, gutter: size === 'large' ? 0.5 : 0 }, TitleBlockProps, { sx: __assign({ flex: 1 }, TitleBlockProps.sx) })),
        !!endAdornment && React.createElement(EndAdornment, { className: classes.endAdornment }, endAdornment)));
});
